export enum StorageKey {
  Token = "token",
  User = "user",
}

export type ApplicationStoreProps = {
  tokenExpired: boolean;
};

export type ApplicationStore = {
  setApplicationProps: (applicationProps: ApplicationStoreProps) => unknown;
  applicationProps: ApplicationStoreProps;
};
